import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_FAMILYCONTACT,
  DELETE_FAMILYCONTACT,
  UPDATE_FAMILYCONTACT,
  ADD_NEW_FAMILYCONTACT,
} from "./actionType";

import {
  getFamilyContactSuccess,
  getFamilyContactFail,
  deleteFamilyContactSuccess,
  deleteFamilyContactFail,
  updateFamilyContactSuccess,
  updateFamilyContactFail,
  addFamilyContactSuccess,
  addFamilyContactFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveFamilyContactApi,
  getFamilyContactApi,
  updateFamilyContactApi,
  deleteFamilyContactApi,
  addNewFamilyContactApi
} from "../../helpers/backend_helper";

function* getFamilyContact({ payload: familyContact }) {
  try {
    const response = yield call(getFamilyContactApi, familyContact);
    yield put(getFamilyContactSuccess(GET_FAMILYCONTACT, response.data));
  } catch (error) {
    yield put(getFamilyContactFail(GET_FAMILYCONTACT, error));
  }
}

function* onUpdateFamilyContact({ payload: familyContact }) {
  try {
    const response = yield call(updateFamilyContactApi, familyContact);
    yield put(updateFamilyContactSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateFamilyContactFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteFamilyContact({ payload: familyContact }) {
  try {
    const response = yield call(deleteFamilyContactApi, familyContact);
    yield put(deleteFamilyContactSuccess({ familyContact, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteFamilyContactFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewFamilyContact({ payload: familyContact }) {
  try {
    const response = yield call(addNewFamilyContactApi, familyContact);
    yield put(addFamilyContactSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addFamilyContactFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetFamilyContact() {
  yield takeEvery(GET_FAMILYCONTACT, getFamilyContact);
}

export function* watchUpdateFamilyContact() {
  yield takeEvery(UPDATE_FAMILYCONTACT, onUpdateFamilyContact);
}

export function* watchDeleteFamilyContact() {
  yield takeEvery(DELETE_FAMILYCONTACT, onDeleteFamilyContact);
}

export function* watchAddNewFamilyContact() {
  yield takeEvery(ADD_NEW_FAMILYCONTACT, onAddNewFamilyContact);
}

function* familyContactSaga() {
  yield all([
    fork(watchGetFamilyContact),
    fork(watchDeleteFamilyContact),
    fork(watchUpdateFamilyContact),
    fork(watchAddNewFamilyContact)
  ]);
}

export default familyContactSaga;
